<template lang="html">
    <p class="text-block"><slot></slot></p>
</template>

<script>
export default {
    name: "TextBlock",
};
</script>

<style>
.text-block {
    font-size: 1.125rem;
    line-height: 1.8;

    strong {
        color: #202020;
        font-weight: 500;
    }

    .link {
        color: #202020;
        text-decoration: underline;
        word-break: break-all;
        transition: color 0.2s;

        &:hover {
            color: #707070;
        }
    }
}
</style>
